import { render, staticRenderFns } from "./TrainorderRight.vue?vue&type=template&id=e4e647dc&scoped=true"
import script from "./TrainorderRight.vue?vue&type=script&lang=js"
export * from "./TrainorderRight.vue?vue&type=script&lang=js"
import style0 from "./TrainorderRight.vue?vue&type=style&index=0&id=e4e647dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e647dc",
  null
  
)

export default component.exports